export const TYPEKIT_KIT_ID = 'req1ouh';
export const GOOGLE_TAG_MANAGER_ID = 'GTM-5HJ5GVK';
export const MAILCHIMP_USER_ID = '4c51e43f1162adc62d41e6ea5';
export const MAILCHIMP_LIST_ID = '7a87ac0c36';
